/*
 * @Author: sheng.jiang 87789771@qq.com
 * @Date: 2023-10-10 10:01:20
 * @LastEditors: sheng.jiang 87789771@qq.com
 * @LastEditTime: 2023-10-10 10:18:31
 * @FilePath: /meimei-ui-vue3/src/store/modules/settings.js
 * @Description:
 *
 */
import defaultSettings from '@/settings'
import { useDynamicTitle } from '@/utils/dynamicTitle'

const { theme: defaultTheme, sideTheme, showSettings, topNav, tagsView, fixedHeader, sidebarLogo, dynamicTitle } = defaultSettings

const storageSetting = JSON.parse(localStorage.getItem('layout-setting')) || ''

const useSettingsStore = defineStore('settings', {
  state: () => ({
    /**
     * 系统标题
     */
    title: '雅云科技管理系统',
    
    /**
     * 主题颜色配置
     * 优先级: settings.js 默认值（不再读取本地缓存，主题色固定）
     * 默认值: #409eff（Element Plus 默认主题蓝）
     */
    theme: defaultTheme || '#409eff',
    
    /**
     * 侧边栏主题
     * theme-dark: 深色主题
     * theme-light: 浅色主题
     * 默认值: theme-dark (从 settings.js 读取)
     */
    sideTheme: storageSetting.sideTheme || sideTheme,
    
    /**
     * 是否显示系统布局配置面板
     * 默认值: true (从 settings.js 读取)
     */
    showSettings: showSettings,
    
    /**
     * 是否显示顶部导航
     * 默认值: false (从 settings.js 读取)
     */
    topNav: storageSetting.topNav === undefined ? topNav : storageSetting.topNav,
    
    /**
     * 是否显示标签视图 (TagsView)
     * 默认值: true (从 settings.js 读取)
     */
    tagsView: storageSetting.tagsView === undefined ? tagsView : storageSetting.tagsView,
    
    /**
     * 是否固定头部
     * 默认值: false (从 settings.js 读取)
     */
    fixedHeader: storageSetting.fixedHeader === undefined ? fixedHeader : storageSetting.fixedHeader,
    
    /**
     * 是否显示侧边栏 Logo
     * 默认值: true (从 settings.js 读取)
     */
    sidebarLogo: storageSetting.sidebarLogo === undefined ? sidebarLogo : storageSetting.sidebarLogo,
    
    /**
     * 是否显示动态标题
     * 默认值: false (从 settings.js 读取)
     */
    dynamicTitle: storageSetting.dynamicTitle === undefined ? dynamicTitle : storageSetting.dynamicTitle,
  }),
  actions: {
    // 修改布局设置
    changeSetting(data) {
      const { key, value } = data
      if (Reflect.has(this, key)) {
        this[key] = value
      }
    },
    // 设置网页标题
    setTitle(title) {
      this.title = title
      useDynamicTitle()
    },
  },
})

export default useSettingsStore
